import { ENDPOINT } from "../../constants/server/api";
import { fetchApiData } from "../../utils/apiUtils";

// ─── GET unique document number ───────────────────────────────
export const getUniqueDocumentNo = (businessSlug, isTaxInvoice = false) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/unique-code`,
    params: { business_slug: businessSlug, is_tax_invoice: isTaxInvoice },
    dispatch,
  });
  return data;
};

// ─── GET paginated list ────────────────────────────────────────
export const getMemberArInvoicePagination =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/pagination/list`,
      params: { business_slug: businessSlug, ...params },
      dispatch,
    });
    return data;
  };

// ─── EXPORT invoices to Excel ─────────────────────────────────
export const getMemberArInvoiceExcel =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/excel/invoices`,
        params: { business_slug: businessSlug, ...params },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ใบแจ้งหนี้.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

// ─── EXPORT receipts to Excel ─────────────────────────────────
export const getMemberArReceiptExcel =
  (businessSlug, params) => async (dispatch) => {
    try {
      const data = await fetchApiData({
        method: "post",
        endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/excel/receipts`,
        params: { business_slug: businessSlug, ...params },
        responseType: "blob",
        dispatch,
      });
      if (data) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ใบเสร็จ.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error(error);
    }
  };

// ─── GET receipt list by member ───────────────────────────────
export const getMemberArReceiptPagination =
  (businessSlug, params) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/receipts/list`,
      params: { business_slug: businessSlug, ...params },
      dispatch,
    });
    return data;
  };

// ─── GET by ID ────────────────────────────────────────────────
export const getMemberArInvoiceById = (id) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}`,
    dispatch,
  });
  return data;
};

// ─── CREATE ───────────────────────────────────────────────────
export const createMemberArInvoice = (requestBody) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}`,
    data: requestBody,
    dispatch,
  });
  return data;
};

// ─── UPDATE ───────────────────────────────────────────────────
export const updateMemberArInvoice =
  (id, requestBody) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}`,
      data: requestBody,
      dispatch,
    });
    return data;
  };

// ─── APPROVE ──────────────────────────────────────────────────
export const approveMemberArInvoice =
  (id, requestBody) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/approve`,
      data: requestBody,
      dispatch,
    });
    return data;
  };

// ─── REJECT ───────────────────────────────────────────────────
export const rejectMemberArInvoice =
  (id, requestBody) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/reject`,
      data: requestBody,
      dispatch,
    });
    return data;
  };

// ─── MANAGE PAYMENT ───────────────────────────────────────────
export const manageMemberArPayment =
  (id, requestBody) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/manage-payment`,
      data: requestBody,
      dispatch,
    });
    return data;
  };

// ─── MANAGE PAYMENT BULK ─────────────────────────────────────
export const manageMemberArPaymentBulk =
  (id, payments) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/manage-payment-bulk`,
      data: { payments },
      dispatch,
    });
    return data;
  };

// ─── GET DEBT TRANSACTIONS FOR MEMBER ────────────────────────
export const getMemberDebtTransactions =
  (businessSlug, memberId, search) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/debt-transactions`,
      params: {
        business_slug: businessSlug,
        member_id: memberId,
        ...(search ? { search } : {}),
      },
      dispatch,
    });
    return data;
  };

// ─── ISSUE RECEIPT ────────────────────────────────────────────
export const issueReceipt =
  (id, receiptInvoiceId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/payment/${receiptInvoiceId}/issue-receipt`,
      dispatch,
    });
    return data;
  };

// ─── CANCEL RECEIPT ───────────────────────────────────────────
export const cancelReceipt =
  (id, receiptInvoiceId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/payment/${receiptInvoiceId}/cancel-receipt`,
      dispatch,
    });
    return data;
  };

// ─── UPDATE PAYMENT RECEIPT ───────────────────────────────────
export const updateMemberArPayment =
  (id, receiptInvoiceId, requestBody) => async (dispatch) => {
    const data = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/payment/${receiptInvoiceId}`,
      data: requestBody,
      dispatch,
    });
    return data;
  };

// ─── DELETE PAYMENT RECEIPT ───────────────────────────────────
export const deleteMemberArPayment =
  (id, receiptInvoiceId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "delete",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}/payment/${receiptInvoiceId}`,
      dispatch,
    });
    return data;
  };

// ─── DELETE ───────────────────────────────────────────────────
export const deleteMemberArInvoice =
  (id, businessSlug) => async (dispatch) => {
    const data = await fetchApiData({
      method: "delete",
      endpoint: `${ENDPOINT.MEMBER_AR_INVOICE}/${id}`,
      params: { business_slug: businessSlug },
      dispatch,
    });
    return data;
  };
